import { curry } from 'ramda';

const roundToNDecimals = (n: number, num: number): number =>
  Math.round((num + Number.EPSILON) * Math.pow(10, n)) / Math.pow(10, n);

export default curry(roundToNDecimals);
